const normalizeId = (value) => {
  if (value === undefined || value === null) return '';
  return String(value).trim();
};

const uniqueIds = (ids) => {
  const seen = new Set();
  return ids
    .map(normalizeId)
    .filter(Boolean)
    .filter((id) => {
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
};

export const getExactLinkedBookingId = (conversation) => {
  const primaryId = normalizeId(conversation?.linkedBookingID);
  if (primaryId) return primaryId;

  const linkedIds = uniqueIds(Array.isArray(conversation?.linkedBookingIDs) ? conversation.linkedBookingIDs : []);
  if (linkedIds.length === 1) return linkedIds[0];
  if (linkedIds.length > 1) return null;

  const bookingRelationIds = uniqueIds(
    Array.isArray(conversation?.bookings?.items)
      ? conversation.bookings.items.map((booking) => booking?.id)
      : []
  );
  if (bookingRelationIds.length === 1) return bookingRelationIds[0];

  return null;
};

export const getUniqueLinkedBookingIds = (conversation) => uniqueIds([
  conversation?.linkedBookingID,
  ...(Array.isArray(conversation?.linkedBookingIDs) ? conversation.linkedBookingIDs : []),
  ...(Array.isArray(conversation?.bookings?.items)
    ? conversation.bookings.items.map((booking) => booking?.id)
    : []),
]);
